(function () {
  // Wait for DOM
  document.addEventListener('DOMContentLoaded', function () {
    // Find all pagination containers on the page
    var paginations = document.querySelectorAll('.slider-pagination');

    paginations.forEach(function(pagination) {
      var sliderId = pagination.dataset.sliderId;
      if (!sliderId) return;

      var slider = document.getElementById(sliderId);
      if (!slider) return;

      // slides: children LI inside the slider
      var slides = Array.prototype.slice.call(slider.querySelectorAll('li'));
      var total = slides.length || 0;
      if (total <= 1) {
        // nothing to paginate
        return;
      }

      // create dots
      pagination.innerHTML = ''; // clear
      var dots = [];
      for (var i = 0; i < total; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'slider-pagination__dot';
        btn.setAttribute('aria-label', (i + 1) + ' / ' + total);
        btn.dataset.index = i;
        if (i === 0) {
          btn.classList.add('active');
          btn.setAttribute('aria-current', 'true');
        }
        pagination.appendChild(btn);
        dots.push(btn);
      }

      // helpers: find prev/next controls associated with this slider
      // They are sibling elements in your markup .slider-button--prev / --next with aria-controls attribute.
      // Fallback: search nearest .slider-buttons container
      var sliderContainer = slider.closest('.slider-component') || slider.parentElement;
      var prevBtn = sliderContainer ? sliderContainer.querySelector('.slider-button--prev') : null;
      var nextBtn = sliderContainer ? sliderContainer.querySelector('.slider-button--next') : null;

      // track current index
      var currentIndex = 0;

      // update active class on dots
      function setActiveIndex(idx) {
        if (idx < 0) idx = 0;
        if (idx >= total) idx = total - 1;
        currentIndex = idx;
        dots.forEach(function(d, j) {
          if (j === idx) {
            d.classList.add('active');
            d.setAttribute('aria-current', 'true');
          } else {
            d.classList.remove('active');
            d.removeAttribute('aria-current');
          }
        });
      }

      // attempt to move slider to index by simulating clicks on prev/next
      function moveToIndex(targetIndex) {
        targetIndex = Math.max(0, Math.min(total - 1, targetIndex));
        // Fast path: if slider library exposes a data attribute or transform, we could call a method.
        // Generic approach: compute diff and click prev/next required times.
        var diff = targetIndex - currentIndex;
        var clicks = Math.abs(diff);
        if (clicks === 0) return;
        var clickFn = diff > 0 ? function() { nextBtn && nextBtn.click(); } : function() { prevBtn && prevBtn.click(); };
        // perform clicks with tiny delay to allow slider internals to update
        var i = 0;
        var interval = setInterval(function() {
          if (i >= clicks) {
            clearInterval(interval);
            return;
          }
          clickFn();
          i++;
        }, 80);
      }

      // When user clicks a dot -> move slider
      dots.forEach(function(dot) {
        dot.addEventListener('click', function(e) {
          var idx = parseInt(this.dataset.index, 10);
          moveToIndex(idx);
          // optimistic UI update
          setActiveIndex(idx);
        });
      });

      // Update currentIndex when prev/next clicked
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          var newIndex = currentIndex + 1;
          if (newIndex >= total) newIndex = total - 1;
          setActiveIndex(newIndex);
        });
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          var newIndex = currentIndex - 1;
          if (newIndex < 0) newIndex = 0;
          setActiveIndex(newIndex);
        });
      }

      // Also try to detect direct slide changes dispatched by the slider (if any).
      // Many slider implementations dispatch custom events like 'slide:change' or update 'aria-hidden'.
      // Observe the slider for changes to active slide (best-effort).
      var observer = new MutationObserver(function() {
        // try to find which slide is currently visible (the one without aria-hidden or with transform closest to 0)
        var visibleIndex = -1;
        slides.forEach(function(slide, idx) {
          // many sliders set aria-hidden; we use that if available
          if (slide.getAttribute('aria-hidden') === 'false') {
            visibleIndex = idx;
          }
        });
        // fallback: pick first slide with class containing 'is-selected' or 'is-active'
        if (visibleIndex === -1) {
          slides.forEach(function(slide, idx) {
            var cls = slide.className || '';
            if (/is-selected|is-active|active/.test(cls)) visibleIndex = idx;
          });
        }
        // fallback: use transform left value (best-effort)
        if (visibleIndex === -1) {
          slides.forEach(function(slide, idx) {
            var rect = slide.getBoundingClientRect();
            if (rect.left >= 0 && rect.left < window.innerWidth/2) {
              visibleIndex = idx;
            }
          });
        }
        if (visibleIndex >= 0) setActiveIndex(visibleIndex);
      });

      // observe children attributes/class changes
      observer.observe(slider, { childList: false, subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden', 'style'] });

      // initial set
      setActiveIndex(0);

      // If slider changes on load (slides > columns or responsive), re-build dots on resize (debounced)
      var resizeTimer = null;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          // if slide count changed, reconstruct - simple approach: reload page to be safe
          // But we can re-evaluate slides length and rebuild if different.
          var newSlides = Array.prototype.slice.call(slider.querySelectorAll('li'));
          if (newSlides.length !== total) {
            // rebuild by reloading page as a fallback
            window.location.reload();
          }
        }, 200);
      });

    }); // end each pagination
  });
})();
